import { requests } from '../../api/services';
import { MODASH_HEALTH_URL } from '../../utils/Endpoints';

export const ModashService = {
    getModashHealthInfo: () => requests.get(`${MODASH_HEALTH_URL}`),
};
